var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51B6122F-446F-41FD-BC22-38AB77CFE100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "null",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in-/-sign-up---1",
    transform: "translate(-730.000000, -651.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(730.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-3134211-copy",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,-2.43614652e-15 C8.81734286,-2.43614652e-15 5.76514286,1.26428571 3.51471429,3.5148 C1.2642,5.76514286 -8.57142857e-05,8.81751429 -8.57142857e-05,12.0000857 C-8.57142857e-05,15.1826571 1.2642,18.2349429 3.51471429,20.4853714 C5.76505714,22.7358857 8.81742857,24.0001714 12,24.0001714 C14.1063429,24.0001714 16.1757429,23.4456857 18,22.3925143 C19.8242571,21.3391714 21.339,19.8244286 22.3924286,18.0000857 C23.4456,16.1758286 24.0000857,14.1064286 24.0000857,12.0000857 C24.0000857,8.81742857 22.7358,5.76522857 20.4852857,3.5148 C18.2349429,1.26428571 15.1825714,-2.43614652e-15 12,-2.43614652e-15 Z M15.0696429,12.24 L9.40778571,17.8992857 C9.34483714,17.9639057 9.25812,18.0004029 9.16788429,18.0000708 C9.07764857,17.9992315 8.99143286,17.9630709 8.92781571,17.8992857 C8.79606429,17.76636 8.79606429,17.5520743 8.92781571,17.4193286 L14.3492443,12.0000429 L8.92995857,6.58075714 C8.79820714,6.44799857 8.79820714,6.23371286 8.92995857,6.1008 C8.99324143,6.03634714 9.07962429,6.00001714 9.17002714,6.00001714 C9.26026286,6.00001714 9.34681286,6.03634543 9.40992857,6.1008 L15.0717857,11.7600857 C15.2028686,11.89368 15.2018657,12.1079657 15.0694419,12.2402143 L15.0696429,12.24 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.31db1e98108d2b8f7b2a10796992f26f.svg";
export { ForwardRef as ReactComponent };